module.exports = __webpack_public_path__ + "static/img/immortal 1.cdaaf3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/immortal 1.png
// module id = oO7D
// module chunks = 35